import { defineMessages } from 'react-intl';

const messages = defineMessages({
  customizeButton: {
    id: 'App.RentForecast.Customize356010Modal.CustomizeButton',
    defaultMessage: 'Customize 3560-10 Report',
  },
  title: {
    id: 'App.RentForecast.Customize356010Modal.Title',
    defaultMessage: 'Customize 3560-10 Report',
  },
  asOfDate: {
    id: 'App.RentForecast.Customize356010Modal.AsOfDate',
    defaultMessage: 'As of date',
  },
  projectName: {
    id: 'App.RentForecast.Customize356010Modal.ProjectName',
    defaultMessage: 'Project name',
  },
  borrowerName: {
    id: 'App.RentForecast.Customize356010Modal.BorrowerName',
    defaultMessage: 'Borrower name',
  },
  borrowerId: {
    id: 'App.RentForecast.Customize356010Modal.BorrowerId',
    defaultMessage: 'Borrower ID',
  },
  projectNumber: {
    id: 'App.RentForecast.Customize356010Modal.ProjectNumber',
    defaultMessage: 'Project no.',
  },
  line: {
    id: 'App.RentForecast.Customize356010Modal.Line',
    defaultMessage: 'Line',
  },
  identify: {
    id: 'App.RentForecast.Customize356010Modal.Identify',
    defaultMessage: 'Identify',
  },
  currentYear: {
    id: 'App.RentForecast.Customize356010Modal.CurrentYear',
    defaultMessage: 'Current year',
  },
  priorYear: {
    id: 'App.RentForecast.Customize356010Modal.PriorYear',
    defaultMessage: 'Prior year',
  },
  comments: {
    id: 'App.RentForecast.Customize356010Modal.Comments',
    defaultMessage: 'Comments',
  },
  commentPlaceholder: {
    id: 'App.RentForecast.Customize356010Modal.CommentPlaceholder',
    defaultMessage: 'Comment',
  },
  period: {
    id: 'App.RentForecast.Customize356010Modal.Period',
    defaultMessage: '{beginDate} - {endDate}',
  },
  assets: {
    id: 'App.RentForecast.Customize356010Modal.Assets',
    defaultMessage: 'Assets',
  },
  liabilities: {
    id: 'App.RentForecast.Customize356010Modal.Liabilities',
    defaultMessage: "Liabilities and owner's equity",
  },
  agingMismatch: {
    id: 'App.RentForecast.Customize356010Modal.AgingMismatch',
    defaultMessage:
      'Line {lineId} ({column}): the aging lines add up to {sublineTotal}, ' +
      'not {lineTotal}. You can still generate the report.',
  },
  cancel: {
    id: 'App.RentForecast.Customize356010Modal.Cancel',
    defaultMessage: 'Cancel',
  },
  refresh: {
    id: 'App.RentForecast.Customize356010Modal.Refresh',
    defaultMessage: 'Refresh from Intacct',
  },
  generate: {
    id: 'App.RentForecast.Customize356010Modal.Generate',
    defaultMessage: 'Generate 3560-10',
  },
  loadingNotice: {
    id: 'App.RentForecast.Customize356010Modal.LoadingNotice',
    defaultMessage:
      'Loading the 3560-10 from Intacct. This can take up to 3 minutes.',
  },
  loadError: {
    id: 'App.RentForecast.Customize356010Modal.LoadError',
    defaultMessage: 'The 3560-10 data could not be loaded. {error}',
  },
  success: {
    id: 'App.RentForecast.Customize356010Modal.Success',
    defaultMessage: 'Success',
  },
  generateSuccess: {
    id: 'App.RentForecast.Customize356010Modal.GenerateSuccess',
    defaultMessage: 'The 3560-10 was downloaded.',
  },
  error: {
    id: 'App.RentForecast.Customize356010Modal.Error',
    defaultMessage: 'Error',
  },
  generateError: {
    id: 'App.RentForecast.Customize356010Modal.GenerateError',
    defaultMessage: 'The 3560-10 could not be generated. {error}',
  },
});

export default messages;
